import React, { useEffect, createRef } from 'react';
import { useForm } from 'formydable';
import request from 'requestjs';
import Toast from 'Snippets/Toast';
import { Spinner } from 'Snippets/Spinner';
import {
    uid,
	addHiddenEventListener,
	removeHiddenEventListener,
	keyHiddenEvent,
	cookie
} from 'Common/Utils';
import { GoogleAppURL } from 'Common/Constant';

const ComingSoon = () => {
	const { formState, formUpdate, formSubmit } = useForm({
		subscribe: { label: 'subscribe', rules: 'required|email' },
	});

	const subscribe = formState('subscribe');

	const handleSubmit = formSubmit((event) => {
		const cookieKey = "SBC"
		if(cookie.get(cookieKey)) {
			return Toast.create( 
				'you are already subscribed try again tommorow' 
			);
		}
		if (event.isReady()) {
			const key = uid();
			Toast.create(
				<div className="d-flex flex-center-y">
					<Spinner loading={true} />
					subscribing...
				</div>,
				{ key, options: { duration: 20000 } }
			);

			request(GoogleAppURL, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				responseType: 'json',
				body: event.param()+'&action=subscribe'
			})
			.then((response) => {
				if(response.status >= 400) {
					throw Error("")
				}
			})
			.then(() =>
				Toast.create(
					<div className="d-flex flex-center-y">
						<Spinner success={true} />
						We will notify you when we publish something
					</div>,
					{ key, options: { duration: 4000 } }
				)
			)
			.catch(() =>
				Toast.create(
					<div className="d-flex flex-center-y">
						<Spinner success={false} />
						something went wrong try again later
					</div>,
					{ key, options: { duration: 4000 } }
				)
			);
			event.reset();
			cookie.set(cookieKey, "true", 1)
		}
	});
	const expressionRef = createRef();
	useEffect(() => {
		const expression = expressionRef.current;
		const handler = () => {
			expression.classList[document[keyHiddenEvent] ? 'remove' : 'add'](
				'active'
            );
		};
		addHiddenEventListener(handler);
		return () => removeHiddenEventListener(handler);
	}, [expressionRef]);
	return (
		<div className='status-code'>
			<div className='active' ref={expressionRef}>
				<div className='status-lite' data-color-changable={true}>
					<div className='animate-wrench'>
						<i className='mytabworks icon-wrench' />
					</div>
					<i className='mytabworks icon-cog' />
					MING SOON
				</div>
				<div className='hr n-bg' />
				<p className='description n-text-dim-color'>
					We're currently working on creating this library <br />
					subscribe to be notified when something is publish.
				</p>
				<form onSubmit={handleSubmit}>
					<div
						className={`n-form-field${
							subscribe.isInvalid
								? ' n-form-invalid'
								: subscribe.isValidated
								? ' n-form-valid'
								: ''
						}`}>
						<div className='n-input-group'>
							<input
								className='n-form-control'
								type='email'
								name='subscribe'
								placeholder='Enter your e-mail'
								value={subscribe.value}
								onChange={formUpdate}
							/>
							<div className='n-input-group-append'>
								<button className='n-btn' type='submit'>
									Subscribe
								</button>
							</div>
						</div>
						<div className='n-invalid-feedback'>
							{subscribe.isInvalid && subscribe.message}
						</div>
					</div>
				</form>
			</div>
		</div>
	);
};

export default ComingSoon;